<div class="step" [ngClass]="{ active: isActive }">
    @if(isActive()){
    <ng-content></ng-content>
    }
</div>
